"use client";

import { IndustrialTemplateRuntime } from "./IndustrialTemplateRuntime";

export function LaunchpadBoldRuntime({
    languageCode,
}: {
    languageCode?: string | null;
}) {
    return (
        <IndustrialTemplateRuntime
            languageCode={languageCode}
            templateCode="launchpad-bold"
        />
    );
}
